import React from 'react';

const Notifications = () => {
    return(
        <h1>Hello World</h1>
    )
}

export default Notifications;